import { useEffect } from 'react';

/**
 * useReveal
 * Adds the "visible" class to any element with className "reveal"
 * when it scrolls into the viewport. Runs on every render so newly
 * mounted elements (after page switches) are also observed.
 */
function useReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    // Observe every .reveal that hasn't been revealed yet
    document.querySelectorAll('.reveal:not(.visible)').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  });
}

export default useReveal;
